import { useQuery } from "@apollo/client";

import GET_BRIEF from '@graphql/getBrief.graphql';

const useGetBrief = (solutionId) => {
  const { data, ...rest } = useQuery(
    GET_BRIEF,
    {
      variables: {
        solutionId,
      },
    },
  );
  return { brief: data?.getSolution, ...rest };
};

export default useGetBrief;
